import { useDictionarySync } from '@/hooks/use-dictionary-sync'

/** Keeps the Spell Check dictionary in step with other editors of the book. Renders nothing. */
export function DictionarySyncHandler() {
  useDictionarySync()

  return null
}
